import React from "react";
interface ProductPriceSectionProps {
  product: any;
}
const ProductPriceSection: React.FC<ProductPriceSectionProps> = ({
  product,
}) => {
  return (
    <div className="flex items-center md:items-start mx-5 md:mx-0 mb-2">
      <p className="text-xs md:text-xl font-bold">
        {Number(product.unit_price) === 0
          ? "Priced by Add-ons"
          : "$" + product.unit_price}
      </p>
    </div>
  );
};

export default ProductPriceSection;
